import React from 'react';
import { Car, Droplets, Sparkles, ShieldCheck } from 'lucide-react';
import { PackageIcon } from '../data/packages';
const icons = {
  car: Car,
  droplets: Droplets,
  sparkles: Sparkles,
  shield: ShieldCheck
};
export function PackageIconGlyph({
  icon,
  className
}: {
  icon: PackageIcon;
  className?: string;
}) {
  const Icon = icons[icon];
  return <Icon className={className} aria-hidden="true" data-id="element-278" data-mp="15u9z1zowdm6l" />;
}